<script>
  import Link from "@sourcewhale/shared/svelte-design-system/components/atoms/Link.svelte";

  let {
    candidateRole,
    candidateCompany,
    companyId,
    skeleton = false,
  } = $props();

  const handleCompanyClick = () => {
    if (companyId) {
      window.open(`/companies?companyId=${companyId}`, "_blank");
    }
  };
</script>

{#if candidateRole || candidateCompany || skeleton}
  <div class:skeleton>
    {#if candidateRole && candidateCompany}
      {candidateRole} at
    {:else if candidateCompany}
      Works at
    {/if}
    {#if candidateCompany && companyId}
      <Link onclick={handleCompanyClick}>{candidateCompany}</Link>
    {:else if candidateCompany}
      {candidateCompany}
    {:else}
      {candidateRole}
    {/if}
  </div>
{/if}
